import { render, staticRenderFns } from "./abnormal_tax.vue?vue&type=template&id=63bd79ea&scoped=true&"
import script from "./abnormal_tax.vue?vue&type=script&lang=js&"
export * from "./abnormal_tax.vue?vue&type=script&lang=js&"
import style0 from "@/styles/index.scss?vue&type=style&index=0&id=63bd79ea&prod&lang=scss&scoped=true&"
import style1 from "./abnormal_tax.vue?vue&type=style&index=1&id=63bd79ea&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bd79ea",
  null
  
)

export default component.exports